/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a');
    if (!link) return;

    var soldOutOption = link.parentElement && link.parentElement.querySelector('input.sold-out, input.unavailable');
    if (link.getAttribute('aria-disabled') === 'true' || link.classList.contains('sibling__link--sold-out') || soldOutOption) {
      event.preventDefault();
    }
  }, true);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


document.addEventListener('DOMContentLoaded', () => {
  const syncFreeShippingSubtotal = () => {
    const source = document.querySelector('[data-cart-total]');
    if (!source) return;

    const text = source.textContent.trim();
    document.querySelectorAll('[data-free-shipping-subtotal]').forEach((el) => {
      el.textContent = text;
    });
  };

  document.addEventListener('theme:product:added', syncFreeShippingSubtotal);

  const item_plp = document.querySelectorAll('.material_item_plp');

  item_plp.forEach(item => { 
    item.addEventListener('mouseenter', () => {
      const id = item.dataset.id;
      const img = item.dataset.img;
      const price = item.dataset.price;
      const comparePrice = item.dataset.compare_price;
      const container = document.getElementById(id);
      if(container) {
        if (img!='') {
          const imgEl = container.querySelector('.product_item_image img');
          if(imgEl) {
            imgEl.src = img;  
          } 
        }
        if (price!='') {
          const priceEl = container.querySelector('.product_item_prices');
          let price_r='';
          if (comparePrice=='') {
            price_r=`<div class="product_price_main"><div class="regular">${price}</div></div>`;
          } else {
            price_r=`<div class="product_price_main product_price_main_sale"><div class="sale">${comparePrice}</div><div class="regular">${price}</div></div>`;
          }
          priceEl.innerHTML = price_r;
        }
      }
    });
    item.addEventListener('click', () => {
      const id = item.dataset.id;
      const img = item.dataset.img;
      const price = item.dataset.price;
      const comparePrice = item.dataset.compare_price;
      const container = document.getElementById(id);
      if(container) {
        if (img!='') {
          const imgEl = container.querySelector('.product_item_image img');
          if(imgEl) {
            imgEl.src = img;  
          } 
        }
        if (price!='') {
          const priceEl = container.querySelector('.product_item_prices');
          let price_r='';
          if (comparePrice=='') {
            price_r=`<div class="product_price_main"><div class="regular">${price}</div></div>`;
          } else {
            price_r=`<div class="product_price_main product_price_main_sale"><div class="sale">${comparePrice}</div><div class="regular">${price}</div></div>`;
          }
          priceEl.innerHTML = price_r;
        }
      }

    });
    item.addEventListener('mouseleave', () => {
      const id = item.dataset.id;
      const img = item.dataset.main_img;
      const price = item.dataset.main_price;
      const comparePrice = item.dataset.main_compare_price;
      const container = document.getElementById(id);
      if(container) {
        if (img!='') {
          const imgEl = container.querySelector('.product_item_image img');
          if(imgEl) {
            imgEl.src = img;  
          } 
        }
        if (price!='') {
          const priceEl = container.querySelector('.product_item_prices');
          let price_r='';
          if (comparePrice=='') {
            price_r=`<div class="product_price_main"><div class="regular">${price}</div></div>`;
          } else {
            price_r=`<div class="product_price_main product_price_main_sale"><div class="sale">${comparePrice}</div><div class="regular">${price}</div></div>`;
          }
          priceEl.innerHTML = price_r;
        }
      }  
    });
  });
});

function material_item_plp(id,url,price,compare_price) {
  const container = document.getElementById(id);
  if(container) {
    if (url!='') {
      const imgEl = container.querySelector('.product_item_image img');
      if(imgEl) {
        imgEl.src = url;  
      } 
    }
  }
}

function slideDown(element, duration = 300) {
  element.style.height = '0px';
  element.style.overflow = 'hidden';
  element.style.transition = `height ${duration}ms ease`;
  
  const height = element.scrollHeight;
  element.style.height = height + 'px';
  
  setTimeout(() => {
    element.style.height = '';
    element.style.overflow = '';
    element.style.transition = '';
  }, duration);
}
 
function slideUp(element, duration = 300) {
  const height = element.scrollHeight;
  element.style.height = height + 'px';
  element.style.overflow = 'hidden';
  element.style.transition = `height ${duration}ms ease`;
  
  setTimeout(() => {
    element.style.height = '0px';
  }, 10);
  
  setTimeout(() => {
    element.style.display = 'none';
    element.style.height = '';
    element.style.overflow = '';
    element.style.transition = '';
  }, duration);
} 


document.addEventListener('click', function (e) {
  if (e.target.classList.contains('items_blocks__link_btn')) {
    e.preventDefault();
    document.querySelectorAll('.items_blocks__link').forEach(el => {
      el.style.display = 'none';
    });
    document.querySelectorAll('.items_blocks__row_item').forEach(el => {
      el.style.display = 'block';
    });
  }
});



function playVideo(id) { 
    let video = document.getElementById("mp4-video-"+id); 
    let closeBtn = document.getElementById("close-btn-"+id);
    let playBtn = document.querySelector("#play-button-"+id);  
    closeBtn.style.display = "flex";
    playBtn.style.display = "none";  
    video.play(); 
  }


function stopVideoMp4(id) {  
    let video = document.getElementById("mp4-video-"+id); 
    let closeBtn = document.getElementById("close-btn-"+id);
    let playBtn = document.querySelector("#play-button-"+id);  
  closeBtn.style.display = "none";  
  playBtn.style.display = "block";   
  video.pause(); 
} 


document.addEventListener('click', function (e) {
  const title = e.target.closest('.sorting_item_title');
  if (!title) return;
  const item = title.closest('.sorting_item');
  if (!item) return;
  const content = item.querySelector('.sorting_item_dann');
  if (!content) return;
  content.classList.toggle('active');
});




document.addEventListener('click', function (e) {
  const filterLabel = e.target.closest('.main_filters_label');
  if (filterLabel) {
    e.preventDefault();
    const input = document.getElementById(filterLabel.getAttribute('for'));
    if (!input) return;
    input.checked = !input.checked;
    filterLabel.classList.toggle('active', input.checked);
    const activeSort = document.querySelector('.main_sorting_label.is-active');
  const sortBy = activeSort ? activeSort.dataset.sort : 'manual'; 
  updateCollection(sortBy);
    return;
  }

  const sortLabel = e.target.closest('.main_sorting_label');
  if (sortLabel) {
    const item = sortLabel.closest('.sorting_item');
    if (!item) return;
    const title = item.querySelector('.sorting_item_title');
    const dropdown = item.querySelector('.sorting_item_dann');
    if (title) title.textContent = sortLabel.textContent.trim();
    item.querySelectorAll('.main_sorting_label').forEach(el => el.classList.remove('is-active'));
    sortLabel.classList.add('is-active');
    if (dropdown) dropdown.classList.remove('active');
    updateCollection(sortLabel.dataset.sort);
  }
});

function updateCollection(sortBy) {
  const params = new URLSearchParams();

  document.querySelectorAll('.main_filters_label').forEach(label => {
    const input = document.getElementById(label.getAttribute('for'));
    if (input && input.checked) {
      params.append(input.name, input.value);
    }
  });

  if (sortBy) {
    params.set('sort_by', sortBy);
  }

  loadCollection(params);
}

function loadCollection(params) {
  const query = params.toString();
  const url = query
    ? `${window.location.pathname}?${query}`
    : window.location.pathname;

  fetch(url)
    .then(r => r.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newLoop = doc.querySelector('#CollectionLoop');
      const currentLoop = document.querySelector('#CollectionLoop');
      if (newLoop && currentLoop) currentLoop.innerHTML = newLoop.innerHTML;
      history.pushState({}, '', url);
    });
}
 





document.addEventListener('DOMContentLoaded', () => {
  const plans = document.querySelectorAll('input[name="selling_plan"]');
  if (!plans.length) return;

  const params = new URLSearchParams(window.location.search);
  const sellingPlanFromUrl = params.get('selling_plan');

  let activated = false;
 
  if (sellingPlanFromUrl) {
    plans.forEach(plan => {
      if (plan.value === sellingPlanFromUrl) {
        plan.checked = true;
        activated = true;
      }
    });
  }

  if (!activated) {
    const alreadyChecked = document.querySelector('input[name="selling_plan"]:checked');
    if (!alreadyChecked) {
      const indexToActivate = plans.length >= 3 ? 1 : 0;
      plans[indexToActivate].checked = true;
    }
  }
  // Default the visible group to Subscribe & Save on load.
  const subscribeGroup = document.querySelector(
    '.product__subs__group--plan input[name="selling-plan-group"][data-toggles-group]'
  );
  if (subscribeGroup && !subscribeGroup.checked) {
    subscribeGroup.checked = true;
    subscribeGroup.dispatchEvent(new Event('change', { bubbles: true }));
  }
 
  function updateUI() {
    const activePlan = document.querySelector('input[name="selling_plan"]:checked');
    if (!activePlan) return;

    const procentEl = document.getElementById('subs_procent');
    const priceEl = document.getElementById('subs_subscribe_price');
    const procent = activePlan.dataset.procent;

    if (procentEl && activePlan.dataset.procent !== undefined) {
      procentEl.textContent = procent;
    }

    const productContent = document.querySelector('.product__content'); 
    let variantId = null; 
    if (productContent) {
      const variantInput = productContent.querySelector('input[type="hidden"][name="id"]');
      if (variantInput) {
        variantId = variantInput.value;
      }
    } 
    if (
  var_sub_price[variantId] &&
  var_sub_price[variantId][procent]
) {
  priceEl.innerHTML = var_sub_price[variantId][procent];
  }
}
 
  updateUI();
  
  document.addEventListener('change', (e) => {
    if (e.target.matches('input[name="selling_plan"]')) {
      updateUI();
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const productImages = document.querySelector('product-images');
  const dotsContainer = document.querySelector('[data-product-gallery-dots]');
  if (!productImages || !dotsContainer) return;

  const syncDots = () => {
    const activeId = productImages.getAttribute('data-active-media');
    dotsContainer.querySelectorAll('[data-gallery-dot]').forEach((dot) => {
      const isActive = dot.getAttribute('data-media-id') === activeId;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  dotsContainer.addEventListener('click', (e) => {
    const dot = e.target.closest('[data-gallery-dot]');
    if (!dot) return;
    productImages.dispatchEvent(
      new CustomEvent('theme:media:select', {
        bubbles: true,
        detail: { id: dot.getAttribute('data-media-id') },
      })
    );
  });

  const observer = new MutationObserver(syncDots);
  observer.observe(productImages, { attributes: true, attributeFilter: ['data-active-media'] });
  syncDots();
});

document.addEventListener('DOMContentLoaded', () => {
  const dataEl = document.querySelector('[data-sheets-variants]');
  if (!dataEl) return;

  const selector = dataEl.closest('.selector--sheets');
  if (!selector) return;

  let variants = [];
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!variants.length) return;

  const sheetsIndex = parseInt(dataEl.getAttribute('data-sheets-index'), 10) || 0;
  const cards = Array.from(selector.querySelectorAll('[data-sheets-card]'));
  if (!cards.length) return;

  const formatMoney = (cents) => window.theme.formatMoney(cents, window.theme.moneyFormat);

  const findVariant = (options, sheetsValue) => {
    const exact = variants.find((variant) =>
      variant.options.every((option, index) => option === options[index])
    );
    return exact || variants.find((variant) => variant.options[sheetsIndex] === sheetsValue);
  };

  const update = (selectedOptions) => {
    let baseUnit = 0;

    cards.forEach((card, index) => {
      const sheetsValue = card.getAttribute('data-sheets-value');
      const qty = parseInt(card.getAttribute('data-sheets-qty'), 10) || 0;

      const wanted = selectedOptions.slice();
      wanted[sheetsIndex] = sheetsValue;

      const variant = findVariant(wanted, sheetsValue);
      if (!variant) return;

      const price = variant.price;
      const compare = variant.compare || 0;
      const onSale = compare > price;
      const baseForUnit = onSale ? compare : price;

      let unitBase = 0;
      let unitMoney = '';
      if (qty > 0) {
        unitBase = baseForUnit / qty;
        unitMoney = formatMoney(Math.round(price / qty));
      }

      let discount = onSale ? Math.floor(((compare - price) * 100) / compare) : 0;

      if (index === 0) {
        baseUnit = unitBase;
      } else if (discount === 0 && baseUnit > 0 && unitBase > 0 && unitBase < baseUnit) {
        discount = Math.round(((baseUnit - unitBase) * 100) / baseUnit);
      }

      const priceEl = card.querySelector('[data-sheets-price]');
      const compareEl = card.querySelector('[data-sheets-compare]');
      const unitEl = card.querySelector('[data-sheets-unit]');
      const saveEl = card.querySelector('[data-sheets-save]');
      const badgeEl = card.querySelector('[data-sheets-badge]');

      if (badgeEl) {
        const badgeText = variant.badge || '';
        badgeEl.textContent = badgeText;
        badgeEl.hidden = badgeText === '';
        if (variant.badge_bg) {
          badgeEl.style.setProperty('--badge-bg', variant.badge_bg);
        } else {
          badgeEl.style.removeProperty('--badge-bg');
        }
      }

      if (priceEl) priceEl.innerHTML = formatMoney(price);
      if (unitEl) unitEl.innerHTML = unitMoney ? `${unitMoney} / sheet` : '';

      if (compareEl) {
        compareEl.innerHTML = onSale ? formatMoney(compare) : '';
        compareEl.hidden = !onSale;
      }

      if (saveEl) {
        if (discount > 0) {
          saveEl.className = 'sheets-card__save';
          saveEl.textContent = `Save ${discount}%`;
        } else {
          saveEl.className = 'sheets-card__regular';
          saveEl.textContent = 'Regular Price';
        }
      }
    });
  };

  document.addEventListener('theme:variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant || !variant.options) return;
    update(variant.options);
  });
});

/* Delivery frequency dropdown — presentation only, the selling_plan radios stay untouched */
document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('[data-subs-select]');
  if (!triggers.length) return;

  const syncValue = (wrap) => {
    const valueEl = wrap.querySelector('[data-subs-select-value]');
    const checked = wrap.querySelector('input[name="selling_plan"]:checked');
    if (!valueEl || !checked) return;
    const label = checked.closest('label');
    const title = label && label.querySelector('[data-subs-plan-title]');
    valueEl.textContent = title ? title.textContent.trim() : checked.value;
  };

  const toggle = (trigger, e) => {
    e.preventDefault();
    e.stopPropagation();
    const wrap = trigger.closest('.product__subs__plans');
    if (wrap) wrap.classList.toggle('is-open');
  };

  document.querySelectorAll('.product__subs__plans').forEach(syncValue);

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => toggle(trigger, e));
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') toggle(trigger, e);
    });
  });

  document.addEventListener('change', (e) => {
    if (!e.target.matches('input[name="selling_plan"]')) return;
    const wrap = e.target.closest('.product__subs__plans');
    if (!wrap) return;
    syncValue(wrap);
    wrap.classList.remove('is-open');
  });

  document.addEventListener('click', (e) => {
    document.querySelectorAll('.product__subs__plans.is-open').forEach((wrap) => {
      if (!wrap.contains(e.target)) wrap.classList.remove('is-open');
    });
  });
});

/* One-time purchase price.
   Theme JS refreshes this node from an async section fetch (including on the
   initial pushState), which can land with a stale Liquid render. Rebuild the
   compare-at price from the variant JSON so the first paint matches later ones. */
document.addEventListener('DOMContentLoaded', () => {
  const wrap = document.getElementById('requires_subscribe_price');
  if (!wrap) return;

  const priceParts = (cents, className) => {
    const formatted = window.theme.formatMoney(cents, window.theme.moneyFormat);
    const dot = formatted.indexOf('.');
    const units = dot === -1 ? formatted : formatted.slice(0, dot);
    const decimals = dot === -1 ? '' : formatted.slice(dot + 1);
    return `<div class="${className}">${units}<sup>${decimals}</sup></div>`;
  };

  let markup = null;
  let writing = false;

  const apply = () => {
    if (markup === null || wrap.innerHTML === markup) return;
    writing = true;
    wrap.innerHTML = markup;
    writing = false;
  };

  const renderFromVariant = (variant) => {
    if (!variant || typeof variant.price !== 'number') return;

    const compare = Number(variant.compare_at_price) || 0;
    const onSale = compare > variant.price;

    markup =
      '<div class="subs_price">' +
      (onSale ? priceParts(compare, 'sale') : '') +
      priceParts(variant.price, 'regular') +
      '</div>';

    apply();
  };

  const syncFromProductJson = () => {
    const jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl) return;

    let product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    const variants = product.variants || [];
    if (!variants.length) return;

    const idEl = document.querySelector('product-component input[name="id"], .product__content input[name="id"]');
    const selectedId = idEl ? Number(idEl.value) : 0;
    const variant =
      variants.find((item) => item.id === selectedId) ||
      product.selected_or_first_available_variant ||
      variants[0];

    renderFromVariant(variant);
  };

  document.addEventListener('theme:variant:change', (event) => {
    renderFromVariant(event.detail && event.detail.variant);
  });

  // Paint immediately, then again after the theme's first section fetch can race in.
  syncFromProductJson();
  window.setTimeout(syncFromProductJson, 0);

  new MutationObserver(() => {
    if (!writing) apply();
  }).observe(wrap, { childList: true, subtree: true });
});

(function () {
  const initCartMakers = (root) => {
    const scroller = root.querySelector('[data-makers-scroller]');
    if (!scroller || root.dataset.makersReady === 'true') return;

    root.dataset.makersReady = 'true';

    const cards = Array.from(root.querySelectorAll('[data-makers-card]'));
    const prev = root.querySelector('[data-makers-prev]');
    const next = root.querySelector('[data-makers-next]');
    const dots = Array.from(root.querySelectorAll('[data-makers-dot]'));

    const maxScrollLeft = () => Math.max(0, scroller.scrollWidth - scroller.clientWidth);

    const getIndex = () => {
      if (!cards.length) return 0;

      const maxScroll = maxScrollLeft();
      if (maxScroll === 0) return 0;
      if (scroller.scrollLeft >= maxScroll - 8) return cards.length - 1;

      const start = cards[0].offsetLeft;
      let best = 0;
      let bestDistance = Infinity;

      cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - start - scroller.scrollLeft);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = index;
        }
      });

      return best;
    };

    const goTo = (index) => {
      const card = cards[index];
      if (!card) return;

      const maxScroll = maxScrollLeft();
      let left = card.offsetLeft - cards[0].offsetLeft;
      if (index >= cards.length - 1) left = maxScroll;

      scroller.scrollTo({
        left,
        behavior: 'smooth',
      });
    };

    const syncControls = () => {
      const index = getIndex();

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });

      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= cards.length - 1;
    };

    prev?.addEventListener('click', () => goTo(Math.max(0, getIndex() - 1)));
    next?.addEventListener('click', () => goTo(Math.min(cards.length - 1, getIndex() + 1)));

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => goTo(index));
    });

    scroller.addEventListener('scroll', syncControls, { passive: true });
    syncControls();

    root.addEventListener('click', (event) => {
      const addBtn = event.target.closest('[data-makers-add]');
      if (!addBtn || addBtn.disabled) return;
      if (!root.contains(addBtn)) return;

      event.preventDefault();
      document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          detail: {
            button: addBtn,
          },
        })
      );
    });
  };

  const initAllCartMakers = (scope) => {
    (scope || document).querySelectorAll('[data-cart-makers]').forEach(initCartMakers);
  };

  document.addEventListener('DOMContentLoaded', () => initAllCartMakers());
  document.addEventListener('shopify:section:load', (event) => initAllCartMakers(event.target));
})();
